export default __webpack_public_path__ + "static/media/Medium-branded-DeepRacer-GUI-bordered-945px-604px.jpg.b624a82f.webp";